import { selector } from 'recoil';

import { currentRole } from 'pages/Login/state';
import { jwtData } from 'pages/OnBoarding/state';
import { constantsAtom } from 'utils/hooks/useConstants';

export const computedNavLinks = selector({
  key: 'app-bar-nav-links',
  get: ({ get }) => {
    const tokenData = get(jwtData);
    const myCurrentRole = get(currentRole);
    const CONSTANTS = get(constantsAtom);

    if (!tokenData) {
      return [];
    }

    const NAV_LINKS = [
      {
        label: 'QC',
        link: '/',
        allowedRoles: [
          CONSTANTS.ROLE.ROLE_ADMIN,
          CONSTANTS.ROLE.ROLE_SUB_ADMIN,
          CONSTANTS.ROLE.ROLE_BUOY_MAINTAINER
        ]
      },
      {
        label: 'Cruise Data Upload',
        link: '/cruise-data-upload',
        allowedRoles: [
          CONSTANTS.ROLE.ROLE_ADMIN,
          CONSTANTS.ROLE.ROLE_SUB_ADMIN,
          CONSTANTS.ROLE.ROLE_BUOY_MAINTAINER
        ]
      },
      {
        label: 'Events',
        link: '/events',
        allowedRoles: [
          CONSTANTS.ROLE.ROLE_ADMIN,
          CONSTANTS.ROLE.ROLE_SUB_ADMIN,
          CONSTANTS.ROLE.ROLE_BUOY_MAINTAINER
        ]
      },
      {
        label: 'Users',
        link: '/users',
        allowedRoles: [CONSTANTS.ROLE.ROLE_ADMIN, CONSTANTS.ROLE.ROLE_SUB_ADMIN]
      },
      {
        label: 'Parameters',
        link: '/parameters',
        allowedRoles: [
          CONSTANTS.ROLE.ROLE_ADMIN,
          CONSTANTS.ROLE.ROLE_SUB_ADMIN,
          CONSTANTS.ROLE.ROLE_BUOY_MAINTAINER
        ]
      },
      {
        label: 'Owners',
        link: '/owners',
        allowedRoles: [
          CONSTANTS.ROLE.ROLE_ADMIN,
          CONSTANTS.ROLE.ROLE_SUB_ADMIN,
          CONSTANTS.ROLE.ROLE_DEVELOPER_ADMIN
        ]
      },
      {
        label: 'On Boarding',
        link: '/instrument-on-boarding',
        allowedRoles: [
          CONSTANTS.ROLE.ROLE_ADMIN,
          CONSTANTS.ROLE.ROLE_SUB_ADMIN,
          CONSTANTS.ROLE.ROLE_DEVELOPER_ADMIN,
          CONSTANTS.ROLE.ROLE_DEVELOPER
        ]
      },
      {
        label: 'API Keys',
        link: '/apikeys',
        allowedRoles: [CONSTANTS.ROLE.ROLE_ADMIN, CONSTANTS.ROLE.ROLE_SUB_ADMIN]
      }
    ];
    const result = NAV_LINKS.map((v) => ({
      ...v,
      allowedRoles: v.allowedRoles.filter((role) => role !== undefined)
    })).filter((v) => v.allowedRoles.includes(myCurrentRole));
    return result;
  }
});
